import request from "@/http/request"
import {
  selectAllLevelSubjectCourse,
  selectLevelSubjectCourseByRequirement,
  getLevelSubjectCourseRelation,
  delLevelSubjectCourse,
  importLevelSubjectCourse,
  getLevel,
  addLevelSubjectCourse,
  selectLevelSubjectCoursePlugs,
  insertLevel,
  editLevel,
  deleteLevel,
  getLevelBlurred,
  getLevelListByRelation,
  getSubjectListByLevel,
  getCourseListByLevelAndSubject,
  getPlaceInfo,
  getInfo,
  delInfo,
  updateInfoiPhone,
  saveInfo,
  exportLevelSubjectCourseByRequirement,
  exportLevelBlurred
} from '@/http/api'

export const exportLevelSubjectCourseByRequirementAPI = (data) => {
  return request({
    url: exportLevelSubjectCourseByRequirement,
    data
  })
}

export const exportLevelBlurredAPI = (data) => {
  return request({
    url: exportLevelBlurred,
    data
  })
}

export const getLevelListByRelationFN = (data) => {
  return request({
    url: getLevelListByRelation,
    data
  })
}

export const getSubjectListByLevelFN = (data) => {
  return request({
    url: getSubjectListByLevel,
    data
  })
}

export const getCourseListByLevelAndSubjectFN = (data) => {
  return request({
    url: getCourseListByLevelAndSubject,
    data
  })
}

export const selectAllLSC = (data) => {
  return request({
    url: selectAllLevelSubjectCourse,
    data
  })
}
export const selectAllLSCByReq = (data) => {
  return request({
    url: selectLevelSubjectCourseByRequirement,
    data
  })
}
export const getLSCRelation = (data) => {
  return request({
    url: getLevelSubjectCourseRelation,
    data
  })
}
export const delLevelSubjectCourses = (data) => {
  return request({
    url: delLevelSubjectCourse,
    data
  })
}
export const importLevelSubjectCourseSet = (data) => {
  return request({
    url: importLevelSubjectCourse,
    data,
    isUpload: true
  })
}
export const getLevelList = () => {
  return request({
    url: getLevel,
  })
}
export const addLevelSubjectCourseSet = (data) => {
  return request({
    url: addLevelSubjectCourse,
    data
  })
}
export const selectPlugs = (data) => {
  return request({
    url: selectLevelSubjectCoursePlugs,
    data
  })
}
export const insertLevelSet = (data) => {
  return request({
    url: insertLevel,
    data
  })
}
export const editLevelSet = (data) => {
  return request({
    url: editLevel,
    data
  })
}
export const deleteLevelSet = (data) => {
  return request({
    url: deleteLevel,
    data
  })
}
export const selectLevel = (data) => {
  return request({
    url: getLevelBlurred,
    data
  })
}

export const getPlaceInfofn = (data) => {
  return request({
    url: getPlaceInfo,
    data
  })
}
export const getInfoFn =(data)=>{
  return request({
      url:getInfo,
      data
  })
}
export const deletedelInfo =(data)=>{
  return request({
      url:delInfo,
      data
  })
}
export const updateInfoPhone =(data)=>{
  return request({
      url:updateInfoiPhone,
      data
  })
}
export const setsaveInfo =(data)=>{
  return request({
      url:saveInfo,
      data
  })
}